import { handleActions } from 'redux-actions';
import immutable from 'immutability-helper';
import { ActionTypes } from 'src/store/constants';

const initialState = {
    // === EXISTING STATE ===
    status: 'idle', // idle | connecting | connected | disconnected
    selectedGateway: null, // baileys | official | null
    qrModalVisible: false,
    activeTab: '1',
    currentStep: 0,
    qrCode: null,
    isConnecting: false,
    error: null,
    connectionHistory: [],
    response: Object.assign({}),

    // === TAMBAHAN INIT STATE ===
    isInitialized: false,
    isServerOnline: false,
    isBaileysConnected: false,
    isAuthenticated: false,
    serverData: null,
    lastChecked: null,
    activeWa: null,
    // === STATISTICS - SESUAIKAN DENGAN RESPONSE BACKEND ===
    statistics: {
        total: 0,
        success: 0,
        failed: 0,
        details: {
            success: 0,
            user_whatsapp_not_logged: 0,
            gagal: 0,
            terkirim: 0,
            dikirim: 0,
            nomor_tidak_terdaftar: 0,
            gagal_kirim_pesan: 0,
            session_tidak_ditemukan: 0,
        },
        rates: {
            success: 0,
            failed: 0,
            delivery: 0,
        },
        formatted: {
            total: '0',
            success: '0',
            failed: '0',
            successRate: '0%',
            failedRate: '0%',
            deliveryRate: '0%',
            // Detail formatted
            user_whatsapp_not_logged: '0',
            gagal: '0',
            terkirim: '0',
            dikirim: '0',
            nomor_tidak_terdaftar: '0',
            gagal_kirim_pesan: '0',
            session_tidak_ditemukan: '0',
        },
        lastUpdated: null,
    },
};

export const gatewayState = { ...initialState };

export default {
    wa_gateway: handleActions(
        {
            // === EXISTING REDUCERS ===

            // Reset state
            [ActionTypes.RESET_GATEWAY_STATE]: state => immutable(state, {
                status: { $set: 'idle' },
                selectedGateway: { $set: null },
                qrModalVisible: { $set: false },
                activeTab: { $set: '1' },
                currentStep: { $set: 0 },
                qrCode: { $set: null },
                isConnecting: { $set: false },
                error: { $set: null },
                connectionHistory: { $set: [] },
                response: { $set: {} },
                // Reset tambahan
                isInitialized: { $set: false },
                isServerOnline: { $set: false },
                isBaileysConnected: { $set: false },
                isAuthenticated: { $set: false },
                serverData: { $set: null },
                lastChecked: { $set: null },
                activeWa: { $set: null }, // Reset activeWa
                statistics: { $set: initialState.statistics },
            }),

            // Select gateway
            [ActionTypes.GATEWAY_SELECT]: (state, { payload }) => immutable(state, {
                selectedGateway: { $set: payload },
                status: { $set: 'idle' },
            }),

            // Set status
            [ActionTypes.GATEWAY_SET_STATUS]: (state, { payload }) => immutable(state, {
                status: { $set: payload },
            }),

            // QR Modal
            [ActionTypes.GATEWAY_SET_QR_MODAL]: (state, { payload }) => immutable(state, {
                qrModalVisible: { $set: payload },
            }),

            // Active tab
            [ActionTypes.GATEWAY_SET_ACTIVE_TAB]: (state, { payload }) => immutable(state, {
                activeTab: { $set: payload },
            }),

            // Current step
            [ActionTypes.GATEWAY_SET_CURRENT_STEP]: (state, { payload }) => immutable(state, {
                currentStep: { $set: payload },
            }),

            // Connect - loading state
            [ActionTypes.GATEWAY_CONNECT]: state => immutable(state, {
                status: { $set: 'connecting' },
                isConnecting: { $set: true },
                error: { $set: null },
            }),

            // Connect success
            [ActionTypes.GATEWAY_CONNECT_SUCCESS]: (state, { payload }) => immutable(state, {
                status: { $set: 'connected' },
                isConnecting: { $set: false },
                isBaileysConnected: { $set: true }, // TAMBAHAN
                isAuthenticated: { $set: true },     // TAMBAHAN
                response: { $set: payload },
                activeWa: { $set: payload?.phone || payload?.activeWa || state.activeWa }, // Update activeWa
                connectionHistory: {
                    $push: [{
                        timestamp: new Date().toISOString(),
                        status: 'connected',
                        data: payload,
                    }],
                },
            }),

            // Connect failed
            [ActionTypes.GATEWAY_CONNECT_FAILED]: (state, { payload }) => immutable(state, {
                status: { $set: 'disconnected' },
                isConnecting: { $set: false },
                isBaileysConnected: { $set: false },
                isAuthenticated: { $set: false },
                error: { $set: payload },
                activeWa: { $set: null }, // Reset activeWa
                connectionHistory: {
                    $push: [{
                        timestamp: new Date().toISOString(),
                        status: 'failed',
                        error: payload,
                    }],
                },
            }),

            // Disconnect
            [ActionTypes.GATEWAY_DISCONNECT]: state => immutable(state, {
                status: { $set: 'disconnected' },
                isConnecting: { $set: false },
                isBaileysConnected: { $set: false },
                isAuthenticated: { $set: false },
                activeWa: { $set: null }, // Reset activeWa
                connectionHistory: {
                    $push: [{
                        timestamp: new Date().toISOString(),
                        status: 'disconnected',
                    }],
                },
            }),

            // === TAMBAHAN INIT REDUCERS ===

            // Start checking server
            [ActionTypes.WA_INIT_CHECK_START]: state => immutable(state, {
                status: { $set: 'loading' },
                error: { $set: null },
                isInitialized: { $set: false },
            }),

            // Check server success

            // === WA INIT CHECK SUCCESS ===
            [ActionTypes.WA_INIT_CHECK_SUCCESS]: (state, { payload }) => {
                // Jika payload memiliki statistics, update statistics
                const stats = payload?.statistics || {};

                return immutable(state, {
                    status: { $set: 'success' },
                    isInitialized: { $set: true },
                    isServerOnline: { $set: payload?.serverOnline || false },
                    isBaileysConnected: { $set: payload?.baileysConnected || false },
                    isAuthenticated: { $set: payload?.authenticated || false },
                    selectedGateway: { $set: payload?.selectedGateway || null },
                    activeWa: { $set: payload?.activeWa || null },
                    serverData: { $set: payload },
                    response: { $set: payload },
                    lastChecked: { $set: new Date().toISOString() },
                    statistics: {
                        $set: {
                            total: stats?.total || 0,
                            success: stats?.success || 0,
                            failed: stats?.failed || 0,
                            details: {
                                success: stats?.details?.success || 0,
                                user_whatsapp_not_logged: stats?.details?.user_whatsapp_not_logged || 0,
                                gagal: stats?.details?.gagal || 0,
                                terkirim: stats?.details?.terkirim || 0,
                                dikirim: stats?.details?.dikirim || 0,
                                nomor_tidak_terdaftar: stats?.details?.nomor_tidak_terdaftar || 0,
                                gagal_kirim_pesan: stats?.details?.gagal_kirim_pesan || 0,
                                session_tidak_ditemukan: stats?.details?.session_tidak_ditemukan || 0,
                            },
                            rates: {
                                success: stats?.rates?.success || 0,
                                failed: stats?.rates?.failed || 0,
                                delivery: stats?.rates?.delivery || 0,
                            },
                            formatted: {
                                total: stats?.formatted?.total || '0',
                                success: stats?.formatted?.success || '0',
                                failed: stats?.formatted?.failed || '0',
                                successRate: stats?.formatted?.successRate || '0%',
                                failedRate: stats?.formatted?.failedRate || '0%',
                                deliveryRate: stats?.formatted?.deliveryRate || '0%',
                                user_whatsapp_not_logged: stats?.formatted?.user_whatsapp_not_logged || '0',
                                gagal: stats?.formatted?.gagal || '0',
                                terkirim: stats?.formatted?.terkirim || '0',
                                dikirim: stats?.formatted?.dikirim || '0',
                                nomor_tidak_terdaftar: stats?.formatted?.nomor_tidak_terdaftar || '0',
                                gagal_kirim_pesan: stats?.formatted?.gagal_kirim_pesan || '0',
                                session_tidak_ditemukan: stats?.formatted?.session_tidak_ditemukan || '0',
                            },
                            lastUpdated: new Date().toISOString(),
                        }
                    },
                });
            },

            // Check server failed
            [ActionTypes.WA_INIT_CHECK_FAILED]: (state, { payload }) => immutable(state, {
                status: { $set: 'error' },
                isInitialized: { $set: false },
                isServerOnline: { $set: false },
                isBaileysConnected: { $set: false },
                isAuthenticated: { $set: false },
                error: { $set: payload },
                lastChecked: { $set: new Date().toISOString() },
            }),

            // Update status manual
            [ActionTypes.WA_INIT_UPDATE_STATUS]: (state, { payload }) => immutable(state, {
                isServerOnline: { $set: payload?.serverOnline ?? state.isServerOnline },
                isBaileysConnected: { $set: payload?.baileysConnected ?? state.isBaileysConnected },
                isAuthenticated: { $set: payload?.authenticated ?? state.isAuthenticated },
                serverData: { $set: payload?.serverData || state.serverData },
                lastChecked: { $set: new Date().toISOString() },
            }),
        },
        initialState
    ),
};